<template>
  <div>
    <div
      v-show="isShowDatePicker"
      class="loading-box"
    >
      <el-form
        class="loading-form"
        label-position="left"
        label-width="80px"
      >
        <el-form-item label="所属月份">
          <el-date-picker
            v-model="currentDate"
            :picker-options="pickerOptions"
            type="month"
            value-format="yyyy-MM"
            placeholder="请选择所属月份"
            @change="handleDateChange"
          />
        </el-form-item>
      </el-form>
    </div>

    <img
      class="banner"
      :src="banner"
      alt=""
      @click="handleDateClick"
    />
    <div class="rank-header">
      {{currentDate}} {{title}}
    </div>

    <div class="tip-box">
      <p class="tip">仅计算常规课程（不包括公开课及双杀课等），仅计算正常刷卡次数（不计入试课学员）。因请假找其他老师代课的平均人数也计算入内。</p>
    </div>

    <div class="rank-content">
      <div class="row top3">
        <div v-for="(v, k) in list.slice(0, 3)" :key="`top3-${v.id || k}-${v.store_id || ''}`" class="col">
          <div class="number">{{ k + 1 }}</div>
          <div class="rank-info">
            <div class="teacher_pic">
              <v-avatar :value="v.avatar" :class="`teacher-avatar teacher-avatar-${k}`"/>
            </div>
            <div class="teacher_name">
              <span class="name">{{v.nickname}}</span>
              <span class="average">平均{{v.signed_count}}</span>
            </div>
            <div class="branch">{{ v.store_name }}</div>
            <div v-if="v.leave_count" class="absence">旷课{{v.leave_count}}</div>
            <div v-else class="quanqin">全勤</div>
          </div>
        </div>
      </div>

      <div class="row top7">
        <div v-for="(v, k) in list.slice(3, 10)" :key="`top7-${v.id || k}-${v.store_id || ''}`" class="col-3">
          <div class="number">{{k + 4}}</div>
          <div class="rank-info">
<!--            <div class="teacher_pic">-->
<!--            </div>-->
            <v-avatar class="teacher-avatar-small" :value="v.avatar"/>
            <div v-if="v.leave_count" class="absence">旷课{{v.leave_count}}</div>
            <div v-else class="quanqin">全勤</div>
          </div>
          <div class="teacher_name">
            <span class="name">{{v.nickname}}</span>
            <span class="average">平均{{v.signed_count}}</span>
          </div>
          <div class="branch">{{ v.store_name }}</div>

        </div>
      </div>

      <div v-if="list.length > 7" class="other">
        <div v-for="(v, k) in list.slice(10, halfLength)" :key="`left-${v.id || k}-${v.store_id || ''}`" class="list">
          <div class="teacher_name">
            <span class="name">{{k + 11}}.{{v.nickname}}({{v.store_name}})</span>
            <span class="average">
                平均人数 {{v.signed_count}} 人，
                <span v-if="v.leave_count" class="danger-color">
                  旷课 <strong>{{v.leave_count}}</strong> 节
                </span>
                <span v-else class="success-color">
                  <strong>全勤</strong>
                </span>
              </span>
          </div>
        </div>

        <div class="half-line">中位线</div>

        <div v-for="(v, k) in list.slice(halfLength)" :key="`right-${v.id || k}-${v.store_id || ''}`" class="list">
          <div class="teacher_name">
            <span class="name">{{k + halfLength + 1}}.{{v.nickname}}({{v.store_name}})</span>
            <span class="average">
                平均人数 {{v.signed_count}} 人，
                <span v-if="v.leave_count" class="danger-color">
                  旷课 <strong>{{v.leave_count}}</strong> 节
                </span>
                <span v-else class="success-color">
                  <strong>全勤</strong>
                </span>
              </span>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { getTeacherRankList } from "@/api/teacher";

export default {
  props: {
    banner: String,
    title: String,
    date: {
      type: String,
      default: '',
    },
    courseType: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    currentDate: '',
    list: [],
    halfLength: 0,
    isShowDatePicker: false,
    pickerOptions: {
      disabledDate: (time) => time.getTime() >= Date.now(),
    },
  }),
  methods: {
    async getList() {
      this.isLoading = true;
      const {isError, data} = await getTeacherRankList({
        course_type: this.courseType,
        date: this.currentDate,
      });
      this.isLoading = false;
      if (isError) return;

      if (!data || !data.length) return;
      this.list = data;
      this.halfLength = Math.floor(data.length / 2);
    },
    handleDateClick() {
      this.isShowDatePicker = true;
    },
    handleDateChange() {
      this.isShowDatePicker = false;
      this.getList();
    }
  },
  beforeMount() {
    if (this.date) {
      this.currentDate = this.date;
    } else {
      const now = new Date();
      const year = now.getFullYear();
      const month = now.getMonth() + 1;
      this.currentDate = `${year}-${month}`;
    }

    this.getList();
  },
};
</script>

<style src="./rank.css" scoped/>
